<template>
  <c-timeout-dialog
    :timeLimit="timeLimit"
    @rewind="onRewind"
  >
    <p>会員登録の操作時間が {{timoutMinutes}} 分を超えました。</p>
    <p>
      会員登録は個人情報を扱うため、
      画面からの情報漏えいを最小限に抑えるために、
      会員登録の操作時間に制約を設けております。
    </p>
    <p class="mb-0">大変申し訳ありませんが、最初からやり直しをお願い致します。</p>
  </c-timeout-dialog>
</template>

<script>
import CTimeoutDialog from '@/components/CTimeoutDialog'

import { run } from '@/libs/a'

export default {
  name: 'CTimeout',
  components: {
    CTimeoutDialog
  },
  computed: {
    timoutMinutes () {
      return this.getters['register/timoutMinutes']
    },

    timeLimit () {
      return this.getters['register/timeLimit']
    }
  },
  methods: {
    /**
     * 先頭ページに移動する
     *
     * @param {Function} failed エラー時に呼び出すコールバック関数
     */
    onRewind (failed) {
      run(async () => {
        // 会員登録を初期化する
        this.commit('register/init')

        // 会員登録の先頭ページに移動する
        await this.goTo({ name: 'register' })
      })
    }
  }
}
</script>
